import { Spinner } from '@zapier/design-system';

/**
 * Minimal "Loading" fallback page implementation
 * https://nextjs.org/docs/basic-features/data-fetching#fallback-pages
 */
export function FallbackPage() {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spinner size="large" />
    </div>
  );
}
